/**
 * @generated SignedSource<<517a28576c88d59f866e0261bd9012b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateOrganizationMemberOnboardingChecklistVisibilityInput = {
  hideOnboardingChecklist: boolean;
};
export type OnboardingChecklistContextHideChecklistMutation$variables = {
  input: UpdateOrganizationMemberOnboardingChecklistVisibilityInput;
};
export type OnboardingChecklistContextHideChecklistMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly hideOnboardingChecklist: boolean;
      readonly id: string;
    } | null;
  };
};
export type OnboardingChecklistContextHideChecklistMutation = {
  response: OnboardingChecklistContextHideChecklistMutation$data;
  variables: OnboardingChecklistContextHideChecklistMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOrganizationMemberOnboardingChecklistVisibilityResponse",
    "kind": "LinkedField",
    "name": "updateOrganizationMemberOnboardingChecklistVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganizationMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideOnboardingChecklist",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingChecklistContextHideChecklistMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingChecklistContextHideChecklistMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cfc747203d6a1076d0cd8506325c1c3d",
    "id": null,
    "metadata": {},
    "name": "OnboardingChecklistContextHideChecklistMutation",
    "operationKind": "mutation",
    "text": "mutation OnboardingChecklistContextHideChecklistMutation(\n  $input: UpdateOrganizationMemberOnboardingChecklistVisibilityInput!\n) {\n  response: updateOrganizationMemberOnboardingChecklistVisibility(input: $input) {\n    node {\n      id\n      hideOnboardingChecklist\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51d2864b0347939a1fad6aedc3fb92c7";

export default node;
